module.exports = __webpack_public_path__ + "static/media/etsy.1fc3c49f.svg";